import React, { useState, useEffect, useCallback } from 'react';
import './SelectProjectList.scss';

function SelectProjectList({ projects: propsProjects, selectProject, type, height, caption }) {
  const [projects, setProjects] = useState(propsProjects || []);

  useEffect(() => {
    if (type !== 'available') {
      setProjects(propsProjects || []);
    }
  }, [type, propsProjects]);

  const handleSelectProject = useCallback(
    (project) => {
      if (selectProject) selectProject(project);
    },
    [selectProject]
  );

  const style = height ? { height } : {};
  const projectsToRender =
    type === 'available' ? propsProjects || projects : projects;
  const hasNoAvailableProjects =
    projectsToRender && projectsToRender.length === 0;
  const parentScrolls = type === 'available';

  return (
    <div className="select-project-list">
      {caption && <div className="project-list-caption">{caption}</div>}
      <div
        className={
          'select-project-scroller' +
          (parentScrolls ? ' select-project-scroller--parent-scrolls' : '')
        }
        style={style}
      >
        <div className="select-project-container">
          {!projectsToRender ? (
            <p>No projects selected</p>
          ) : (
            projectsToRender.map((project) => (
              <div
                key={'project_' + project.id}
                className={'project-entry' + project.name}
              >
                {project.name && (
                  <div
                    className="project-name"
                    onClick={() => handleSelectProject(project)}
                  >
                    {project.name}
                  </div>
                )}
              </div>
            ))
          )}
          {type === 'available' && hasNoAvailableProjects && (
            <p className="no-projects-msg">No Projects Found...</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default SelectProjectList;



// WEBPACK FOOTER //
// ./src/containers/ProjectSummaryContainer/AddProjectGroupPopup/SelectProjectList/index.js